

window.addEventListener("DOMContentLoaded", function() {
  window.addEventListener("scroll", scrolling)
  scrolling()
})

function scrolling() {
  
}


function goTo(div, offset) {
  window.scrollTo({
    top: document.querySelector(div).offsetTop - offset,
    left: 0,
    behavior: 'smooth'
  })
}

function is_touch_device() {
  return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}

// Garde universelle : empêche "Cannot read properties of undefined (reading 'style')"
// Désactivée car elle interfère avec le code Shopify
// (function safeStyle() {
//   const origQuerySelector = Document.prototype.querySelector;
//   Document.prototype.querySelector = function(selector) {
//     const el = origQuerySelector.call(this, selector);
//     if (!el) {
//       // Retourne un objet factice pour éviter les erreurs sans polluer la console
//       return { style: {} };
//     }
//     return el;
//   };
// })();
